import type { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Imgix from 'react-imgix';
import "swiper/css";
import { Swiper, SwiperSlide } from 'swiper/react';

type Props = {
    name: string,
    icon: IconDefinition,
    items: string[],
    imageParams: {
        src: string,
        [key: string]: any,
    },
    className?: string,
}

export default function ServiceCard({ name, icon, items, imageParams, className }: Props) {
    return <div className={mc("relative group h-full grid grid-rows-3 grid-cols-1 text-light uppercase text-medium p-8", className)}>
        <div className="z-10">
            <div className="h-max flex justify-between items-center">
                <FontAwesomeIcon icon={icon} size="2x" className="content-center" />
            </div>
        </div>
        <ul className="space-y-2 z-10 font-bold">
            {items.map(item => <li key={`service_${item}`}>
                {item}
            </li>)}
        </ul>
        <div className="flex flex-col-reverse row-start-3 font-bold z-10">
            <h2 className="pb-1 border-b-2 mr-32 group-hover:mr-0 transition-all duration-1500 ease-out">{name}</h2>
        </div>
        <Imgix {...imageParams} className="absolute object-cover w-full h-full top-0 brightness-50 group-hover:brightness-75 saturate-50 group-hover:saturate-125 z-0 group-hover:scale-110 transition-all ease-out duration-1500" />
    </div>
}
